import React, { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Alert } from '../../../../../components/CiscoUi';
import { PageHeading } from '../../../../../components/PageHeading';
import { PrimaryButton } from '../../../../../components/Buttons/PrimaryButton';
import { AddVirtualMachinesRoutes } from '../Add/VirtualMachinesAddRouter';
import { VirtualMachinesRoutes } from '../VirtualMachinesRouter';
import { VirtualMachinesTable } from '../../../../../entities/virtual-machines/components/VirtualMachinesTable';
import { DeleteVMModal } from '../../../../../entities/virtual-machines/components/DeleteVMModal';
import { VM_HELP_LINKS } from '../../../../../constants/user-guide';
import { HelpButtonContainer } from '../../../../../components/HelpButton/container.tsx';
import { VirtualMachinesProps } from './container';

export function VirtualMachines({
  setVirtualMachineToDelete,
  virtualMachineToDelete,
  virtualMachines,
  isLoading,
}: VirtualMachinesProps): ReactElement {
  const { t } = useTranslation();
  const history = useHistory();
  const { url } = useRouteMatch();

  const onDeleteClick = useCallback(
    (virtualMachine: VirtualMachine) => {
      setVirtualMachineToDelete(virtualMachine);
    },
    [setVirtualMachineToDelete],
  );

  return (
    <section className="half-padding-left">
      <PageHeading
        pageTitle={t('virtualMachines.name')}
        ctaBtn={
          <PrimaryButton
            className="btn--wide"
            onClick={() =>
              history.push(
                `${url}${VirtualMachinesRoutes.Add}${AddVirtualMachinesRoutes.Templates}`,
              )
            }
          >
            {t('buttons.new')}
          </PrimaryButton>
        }
      />
      {(isLoading || !!virtualMachines.length) && (
        <VirtualMachinesTable
          onDeleteClick={onDeleteClick}
          virtualMachines={virtualMachines || []}
          loading={isLoading}
        />
      )}

      {!isLoading && virtualMachines.length < 1 && (
        <Alert colour="info">{t('virtualMachines.empty.alertText')}</Alert>
      )}

      {virtualMachineToDelete && (
        <DeleteVMModal
          setVirtualMachineToDelete={setVirtualMachineToDelete}
          virtualMachine={virtualMachineToDelete}
        />
      )}
      <HelpButtonContainer links={VM_HELP_LINKS} />
    </section>
  );
}
